import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import moment from 'moment';

interface TaxpayerHistory {
  period?: string;
  totalIncome?: number;
  totalTax?: number;
  taxes?: {
    accountType: 'SC' | 'MPC' | 'CCSHI' | 'IIT';
    tax: number;
  }[];
}

export default class SelfEmployeeTaxpayerSummaryStatisticsStore extends ListStore<TaxpayerHistory[]> {
  @computed get processedData(): any | undefined {
    if (!this.data) return;
    const items = this.data.map((item) => ({
      ...item,
      isSummary: false,
      periodFormated: moment(item.period).locale('ru').format('MMMM YYYY'),
      totalIncome: item.totalIncome?.toLocaleString('ru-RU'),
      totalTax: item.totalTax?.toLocaleString('ru-RU'),
      SC: item.taxes?.find((tax) => tax.accountType === 'SC')
        ?.tax.toLocaleString('ru-RU'),
    }));
    items.unshift({
      period: '',
      isSummary: true,
      periodFormated: 'ИТОГО',
      totalIncome: this.
        data
        .reduce((acc, cur) => (acc + (cur?.totalIncome || 0)), 0)
        .toLocaleString('ru-RU'),
      totalTax: this.data
        .reduce((acc, cur) => (acc + (cur?.totalTax || 0)), 0)
        .toLocaleString('ru-RU'),
      SC: '',
    });
    return {
      items,
    };
  }


  @action.bound
  async fetch({ taxNo, period }: { taxNo: string; period?: string }) {
    this.isFetching = true;
    try {
      const { data } = await services.selfEmployee.getSummaryStatistics(taxNo, {
        period,
      });
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
